import React, {useState, useEffect} from "react";
import s from "./sessions-history.module.scss";
import { getFormatDate } from "service/format-date";
import { ReactComponent as PlusIcon} from "assets/icons/plus.svg";
import { ReactComponent as ArrowIcon} from "assets/icons/angle-up.svg";
import { ReactComponent as RestartIcon} from "assets/icons/restart.svg";

const SessionsHistory = (props) => {

    const [sessions, setSessions] = useState(props.sessions);
    const [session, setSession] = useState(props.session);
    const [isShowLeftMenu, setIsShowLeftMenu] = useState(props.showLeftMenu);

    const getTwoLabelLang = () => {
        switch(props.selectedLanguage){
            case 'RUS':
                return 'ru'
            case 'ENG':
                return 'en'
            case 'KAZ':
                return 'kk'
        }
    }

    useEffect(() => {
        setSessions(props.sessions);
        setSession(props.session);
        setIsShowLeftMenu(props.showLeftMenu);
    }, [props])

    const selectSession = (selectedSession) => {
        props.loadAiUserSession(selectedSession, props.accountId, props.companyId)
    }
    
    const setSessionToNull = () => {
        props.setSession(null)
    }

    const showOpenClose = () => {
        props.setShowLeftMenu(!isShowLeftMenu)
    }

    const reloadSessionTitle = (sessionId) => {
        props.generateSessionTitle(sessionId, props.accountId, props.companyId, getTwoLabelLang());
    }

    const getTitle = (session) => {
        if(session.session_title){
            if (session.session_title.includes("Task: Create a short title (3-5 words)")){
                return props.getValue('SESSION');
            }

            return session.session_title;
        }
        else{
            return props.getValue('SESSION')
        }
    }

    const sessionsList = sessions && sessions.length ? sessions.map((k, i) => 
                                                        <div className={s.menuButton} key={k.id ? k.id : i}>
                                                            <button  
                                                                    onClick={selectSession.bind(this, k.id)} 
                                                                    disabled={props.isLoading}
                                                                    className={`
                                                                    ${s.sessionButton}
                                                                    ${session && session.id === k.id ? s.selectedSessionButton : ''}
                                                            `}>
                                                                <span className={s.sessionId}>{ getTitle(k) }</span>
                                                                <span className={s.sessionDate}>{ getFormatDate(k.created_at, 'DD.MM.YYYY HH:mm') }</span>
                                                            </button>
                                                            <button 
                                                                className={props.titleLoadingError === k.id ? s.reloadButton+' '+s.reloadButtonError : s.reloadButton} 
                                                                onClick={reloadSessionTitle.bind(this, k.id)}
                                                                title={props.titleLoadingError === k.id ? props.getValue('ASSISTANT_SESSION_TITLE_ERROR') : props.getValue('REGENERATE_SESSION_TITLE')}
                                                                disabled={props.titleLoadingId === k.id || props.isLoading}
                                                            >
                                                                <RestartIcon className={props.titleLoadingId === k.id ? s.spinning : ''} />
                                                            </button>
                                                        </div>)
                                                : <div className={s.noSessionText}>
                                                    <p><b>{ props.getValue('GET_ANSWERS_FOR_MEDIAMONITORING') }</b></p>
                                                    <p>{ props.getValue('ASK_A_QUESTION_ABOUT_MEDIAMONITORING') }</p>
                                                </div>
    
    return (
        <div className={s.SessionsHistory}>
            <div className={s.buttonsBlock}>
                <button className={s.newChat} onClick={()=>{setSessionToNull()}} disabled={props.isLoading}>
                    <PlusIcon />
                    <span>{props.getValue('NEW_CHAT')}</span>
                </button>
                { props.deviceType === 'mobile' || props.deviceType === 'tablet'
                    ?   <button 
                            className={`${s.openCloseMenu} ${isShowLeftMenu ? s.isOpened : s.isClosed}`}
                            onClick={showOpenClose}><ArrowIcon />
                        </button> 
                    : null
                }
            </div>
            <div className={s.SessionsHistoryDescription}>
                <span>{props.getValue('SESSION_HISTORY')}</span>
                <span>{props.getValue('SESSION_HISTORY_STORED')}</span>
            </div>

            {sessionsList}
        </div>
    )
}

export default SessionsHistory;